import { Spacer } from '@sparemin/blockhead';
import React from 'react';

import { captionsViewBlock as block } from '../utils';
import { CaptionsChildViewContextType } from './CaptionsChildViewContext/types';
import CaptionsChildViewDefaultTopSlot from './CaptionsChildViewDefaultTopSlot';
import CaptionsChildViewEditCaptionStyleButton from './CaptionsChildViewEditCaptionStyleButton';
import CaptionsChildViewEditCaptionTextButton from './CaptionsChildViewEditCaptionTextButton';

export const DEFAULT_SWITCH_CAPTION_LABEL = 'Captions';
export const INCLUDE_CAPTIONS_SWITCH_LABEL = 'Include captions';

export const DEFAULT_CHILD_VIEW_PROPS_VALUES: CaptionsChildViewContextType = {
  actionsSlot: <CaptionsChildViewEditCaptionStyleButton />,
  switchLabel: DEFAULT_SWITCH_CAPTION_LABEL,
  startTranscribingWhenEnablingCaptions: false,
};

export const DEFAULT_CHILD_VIEW_PROPS: CaptionsChildViewContextType = {
  ...DEFAULT_CHILD_VIEW_PROPS_VALUES,
  topSlot: <CaptionsChildViewDefaultTopSlot />,
};

export const INCLUDE_CAPTIONS_CHILD_VIEW_PROPS: CaptionsChildViewContextType = {
  ...DEFAULT_CHILD_VIEW_PROPS_VALUES,
  topSlot: <CaptionsChildViewDefaultTopSlot />,
  switchLabel: INCLUDE_CAPTIONS_SWITCH_LABEL,
};

export const CAPTIONS_MANAGEMENT_CHILD_VIEW_PROPS: CaptionsChildViewContextType = {
  ...DEFAULT_CHILD_VIEW_PROPS_VALUES,
  className: block('full-episode-child-view-contents'),
  topSlot: <CaptionsChildViewDefaultTopSlot />,
  actionsSlot: (
    <Spacer
      space="24px"
      orientation="vertical"
      align="center"
      justify="center"
      className={block('actions-slot-fluid')}
    >
      <CaptionsChildViewEditCaptionTextButton />

      <CaptionsChildViewEditCaptionStyleButton />
    </Spacer>
  ),
  switchLabel: INCLUDE_CAPTIONS_SWITCH_LABEL,
  startTranscribingWhenEnablingCaptions: true,
};
